import React from 'react'
import './section6Element.css';

const Section6Element = () => {
  return (
    <div className='section6Element-main-wrapper'>
      <div className='section6Element-inner-wrapper'>
          <h1>01. Discord Market Bots Q2 2022:</h1>
          <p>We will install market bots for holders in the discord. We want to grant you an advantage while trading NFTs by getting insight and analysis of the market.</p>
        </div>
    </div>
  )
}

export default Section6Element